import { useEffect, useRef } from 'react'
import { Animated, Easing, StyleProp, StyleSheet, View, ViewStyle } from 'react-native'
import { DS } from '../../../design-system'

interface InfoRectangleProps extends React.PropsWithChildren {
  customStyle?: StyleProp<ViewStyle>
  row?: boolean
  gap?: number
  dot?: boolean
}

export const InfoRectangle = ({ customStyle, children, row, gap, dot = false }: InfoRectangleProps) => {
  const fadeAnim = useRef(new Animated.Value(0)).current

  useEffect(() => {
    Animated.timing(fadeAnim, {
      toValue: 1,
      duration: 50,
      useNativeDriver: true,
      easing: Easing.bezier(0.42, 0, 0.58, 1)
    }).start()
  }, [fadeAnim])

  return (
    <Animated.View
      style={[
        styles.container,
        { flexDirection: row ? 'row' : undefined },
        { gap },
        {
          transform: [
            {
              translateX: fadeAnim.interpolate({
                inputRange: [0, 1],
                outputRange: [100, 0] // Move from 100 to 0 for fadeInRight effect
              })
            }
          ]
        },
        customStyle
      ]}
    >
      {dot ? <View style={styles.dotStyle} /> : null}
      {children}
    </Animated.View>
  )
}

const styles = StyleSheet.create({
  container: {
    height: 36,
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    borderColor: 'rgba(221, 218, 210, 1)',
    borderRadius: 4,
    borderTopWidth: 1,
    borderBottomWidth: 1
  },
  dotStyle: {
    height: 8,
    width: 8,
    backgroundColor: DS.palette['Brand/Orange'],
    borderRadius: 50
  }
})
